import React from 'react'
import { useHistory,useParams,useLocation} from "react-router-dom";
function Navbar() {
  const history = useHistory();
  
  return (
    <>

    <aside id="sidebar" className="sidebar">

        <ul className="sidebar-nav" id="sidebar-nav">

            <li className="nav-item">
                <a className="nav-link" onClick={()=>history.push('/dashboard')}>
                <i className="bi bi-grid"></i>
                    <span>Dashboard</span>
                </a>
            </li>

            <li className="nav-item">
                <a className="nav-link" onClick={()=>history.push('/create/proposal')} >
                <i className="bi bi-pencil"></i>
                    <span>Create New</span>
                </a>
            </li>

            <li className="nav-item">
                <a className="nav-link collapsed" data-bs-target="#components-nav-pp" data-bs-toggle="collapse" >
                    <i className="bi bi-card-list"></i><span>Purchase Proposal</span><i className="bi bi-chevron-down ms-auto" ></i>
                </a>
                <ul id="components-nav-pp" className="nav-content collapse" data-bs-parent="#sidebar-nav">
                     {/* <li onClick={()=>history.push('/create/proposal')}> <a> <i className="bi bi-circle"></i><span>Create Proposal</span> </a></li> */}
                    <li onClick={()=>history.push('/waiting/proposal')}> <a> <i className="bi bi-circle"></i><span>Waiting</span> </a></li>
                    <li onClick={()=>history.push('/reject/proposal')}> <a> <i className="bi bi-circle"></i><span>Reject</span> </a></li>
                    <li onClick={()=>history.push('/item/reject/proposal')}> <a> <i className="bi bi-circle"></i><span>Item Reject</span> </a></li>
                </ul>
            </li>

            <li className="nav-item">
                <a className="nav-link collapsed" data-bs-target="#components-nav-pr" data-bs-toggle="collapse">
                    <i className="bi bi-card-checklist"></i><span>Purchase Request</span><i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul id="components-nav-pr" className="nav-content collapse" data-bs-parent="#sidebar-nav">
                    <li onClick={()=>history.push('/waiting/request')}> <a> <i className="bi bi-circle"></i><span>Waiting</span> </a></li>
                    <li onClick={()=>history.push('/reject/request')}> <a> <i className="bi bi-circle"></i><span>Rejected</span> </a></li>
                </ul>
            </li>

            <li className="nav-item">
                <a className="nav-link collapsed" data-bs-target="#components-nav-po" data-bs-toggle="collapse">
                    <i className="bi bi-card-heading"></i><span>Purchase Order</span><i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul id="components-nav-po" className="nav-content collapse" data-bs-parent="#sidebar-nav">
                <li onClick={()=>history.push('/purchase/order')}> <a> <i className="bi bi-circle"></i><span>Generated</span> </a></li>
                    <li onClick={()=>history.push('/purchase/order')}> <a> <i className="bi bi-circle"></i><span>Sent</span> </a></li>
                    <li onClick={()=>history.push('/receive/item')}> <a> <i className="bi bi-circle"></i><span>Received</span> </a></li>
                    
                </ul>
            </li>

            <li className="nav-item">
                <a className="nav-link collapsed" data-bs-target="#components-nav-item" data-bs-toggle="collapse">
                    <i className="bi bi-card-heading"></i><span>Item</span><i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul id="components-nav-item" className="nav-content collapse" data-bs-parent="#sidebar-nav">
                    <li onClick={()=>history.push('/add/item')}> <a> <i className="bi bi-circle"></i><span>Register </span> </a></li>
                    <li  onClick={()=>history.push('/list/item')}> <a> <i className="bi bi-circle"></i><span>List </span> </a></li>
                    <li onClick={()=>history.push('/list/item/waiting')}> <a> <i className="bi bi-circle"></i><span>Waiting</span> </a></li>
                    {/* <li onClick={()=>history.push('/list/group/unit')}> <a> <i className="bi bi-circle"></i><span>Group & Unit</span> </a></li> */}
                    <li onClick={()=>history.push('/list/supplier')}> <a> <i className="bi bi-circle"></i><span>Supplier</span> </a></li>
                    
                </ul>
            </li>

            <li className="nav-item">
                <a className="nav-link collapsed" data-bs-target="#components-nav-report" data-bs-toggle="collapse">
                    <i className="bi bi-card-heading"></i><span>Report</span><i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul id="components-nav-report" className="nav-content collapse" data-bs-parent="#sidebar-nav">
                    <li onClick={()=>history.push('/pp/report')}> <a> <i className="bi bi-circle"></i><span>Purchase Request </span> </a></li>
                    {/* <li onClick={()=>history.push('/pr/report')}> <a> <i className="bi bi-circle"></i><span>Purchase Request </span> </a></li> */}
                    <li onClick={()=>history.push('/po/report')}> <a> <i className="bi bi-circle"></i><span>Purchase Order </span> </a></li>
                    <li onClick={()=>history.push('/item/receive/report')}> <a> <i className="bi bi-circle"></i><span>Item Receive </span> </a></li>
                    <li onClick={()=>history.push('/item/report')}> <a> <i className="bi bi-circle"></i><span>Item's </span> </a></li>
                </ul>
            </li>

        </ul>

    </aside>
    
    </>
  )
}

export default Navbar